import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatApiError } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      alert(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="font-display text-2xl font-bold text-white">Reset password</h1>
      <p className="mt-2 text-sm text-white/60">We will email a reset link if the account exists.</p>
      {sent ? (
        <p className="mt-6 text-emerald-300 text-sm">Check your inbox for the reset link.</p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-white/70">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 bg-white/5 border-white/15 text-white" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#D4AF37] text-black font-bold">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
      <p className="mt-6 text-sm text-white/50">
        <Link to="/login" className="text-[#D4AF37] hover:underline">Back to sign in</Link>
      </p>
    </div>
  );
};

export default ForgotPassword;
